export const selectStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "130px", 
  }),
  control: (provided: any) => ({
    ...provided,
    borderRadius: "10px",
    boxShadow: "2px 2px 20px 0px rgba(0, 0, 27, 0.05)",
    outline: "none",
    border: "none",
    padding: "13px 5px",
    backgroundColor: "var(--white-color)",
    fontWeight: 500,
    minHeight: "unset", 
  }),
  input: (provided: any) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  singleValue: (provided: any) => ({
    ...provided,
    fontSize: "14px",
    fontWeight: 500,
  }),
  menu: (provided: any) => ({
    ...provided,
    width: "500px", 
  }),
};